import { findLectriumIframes, onIframesChanged } from './dom-utils'
import { HostIntegrationManager } from './HostIntegrationManager'

const key = '__LECTRIUM_HUB_MANAGER__'

export function integrate(): void {
  if (typeof window === 'undefined') return
  if ((window as any)[key]) return

  const manager = new HostIntegrationManager()
  ;(window as any)[key] = manager

  manager.setIframes(findLectriumIframes())

  onIframesChanged(() => {
    manager.setIframes(findLectriumIframes())
  })

  watchNavigation(() => manager.setUrl(window.location.href))
}

const urlChangeEvent = 'lectrium:urlchange'

/**
 * A single-page dealer site renders the next car's page, badge included, before it pushes the URL,
 * and pushState fires no event. Wrapping it is the only way the badge learns the page it sits on.
 */
function watchNavigation(onChange: () => void): void {
  window.addEventListener('popstate', onChange)
  window.addEventListener('hashchange', onChange)
  window.addEventListener(urlChangeEvent, onChange)

  for (const method of ['pushState', 'replaceState'] as const) {
    const original = history[method]
    history[method] = function (this: History, ...args: Parameters<History['pushState']>) {
      const result = original.apply(this, args)
      window.dispatchEvent(new Event(urlChangeEvent))
      return result
    }
  }
}
